import React from "react";
import Link from "@mui/material/Link";
import PPBANNER from "../../assets/PrivacyPolicy.png";
import { getMeaning } from "../../utils/localization";
import GlobalBanner from "../../components/GlobalBanner";
import { Box, Paper, Divider, Typography } from "@mui/material";

const RetailerAppPolicy = () => {
  return (
    <div>
      <Box sx={{ flex: 1 }}>
        <GlobalBanner backgroundImage={PPBANNER} />
      </Box>

      <Box sx={{ py: 5 }}>
        <Paper elevation={0} sx={{ px: 5 }}>
          <Typography variant="h3" gutterBottom sx={styles.PPHeadingTxt}>
            {getMeaning("PP.PP")}
          </Typography>

          <Typography variant="body2" gutterBottom sx={styles.LabelTxt}>
            {getMeaning("PP.EFCTDTE")}
          </Typography>

          <Divider sx={{ my: 3 }} />

          {/* 1. Introduction */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom sx={styles.HeadingTxt}>
              {getMeaning("PP.INFOWECLCTLBL")}
            </Typography>
            <Typography variant="body1" sx={styles.LabelTxt}>
              {getMeaning("PP.INFOWECLCTDSCP")}
            </Typography>

            {/* <Typography variant="body1" sx={styles.BulletDescpTxt}>
              {getMeaning("PP.INFOWECLCTPNTSONE")}
            </Typography>
            <Typography variant="body1" sx={styles.BulletDescpTxt}>
              {getMeaning("PP.INFOWECLCTPNTSTWO")}
            </Typography>
            <Typography variant="body1" sx={styles.BulletDescpTxt}>
              {getMeaning("PP.INFOWECLCTPNTSTHREE")}
            </Typography>
            <Typography variant="body1" sx={styles.BulletDescpTxt}>
              {getMeaning("PP.INFOWECLCTPNTSFOUR")}
            </Typography> */}
          </Box>

          {/* 2. Eligibility and Account Management */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom sx={styles.HeadingTxt}>
              {getMeaning("PP.HWUSEINFOLBL")}
            </Typography>
            <Typography variant="body1" sx={styles.LabelTxt}>
              {getMeaning("PP.HWUSEINFODSCP")}
            </Typography>

            {/* <Typography variant="body1" sx={styles.BulletDescpTxt}>
              {getMeaning("PP.HWUSEINFOPNTSONE")}
            </Typography>
            <Typography variant="body1" sx={styles.BulletDescpTxt}>
              {getMeaning("PP.HWUSEINFOPNTSTWO")}
            </Typography>
            <Typography variant="body1" sx={styles.BulletDescpTxt}>
              {getMeaning("PP.HWUSEINFOPNTSTHREE")}
            </Typography>
            <Typography variant="body1" sx={styles.BulletDescpTxt}>
              {getMeaning("PP.HWUSEINFOPNTSFOUR")}
            </Typography>
            <Typography variant="body1" sx={styles.BulletDescpTxt}>
              {getMeaning("PP.HWUSEINFOPNTSFIVE")}
            </Typography> */}
          </Box>

          {/* 3. Purpose of the App */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom sx={styles.HeadingTxt}>
              {getMeaning("PP.SHREINFOLBL")}
            </Typography>
            <Typography variant="body1" sx={styles.LabelTxt}>
              {getMeaning("PP.SHREINFODSCP")}
            </Typography>

            <Typography variant="body1" sx={styles.BulletDescpTxt}>
              {getMeaning("PP.SHREINFOPNTSONE")}
            </Typography>
            <Typography variant="body1" sx={styles.BulletDescpTxt}>
              {getMeaning("PP.SHREINFOPNTSTWO")}
            </Typography>
            <Typography variant="body1" sx={styles.BulletDescpTxt}>
              {getMeaning("PP.SHREINFOPNTSTHREE")}
            </Typography>
            <Typography variant="body1" sx={styles.BulletDescpTxt}>
              {getMeaning("PP.SHREINFOPNTSFOUR")}
            </Typography>
            <Typography variant="body1" sx={styles.BulletDescpTxt}>
              {getMeaning("PP.SHREINFOPNTSFIVE")}
            </Typography>
          </Box>

          {/* 4. Information We Collect */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom sx={styles.HeadingTxt}>
              {getMeaning("PP.DTRTNTNLBL")}
            </Typography>

            <Typography variant="body" gutterBottom sx={styles.SubHeadingTxt}>
              {getMeaning("PP.DTRTNTNLBLTWOA")}
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography variant="body1" sx={styles.BoldLabelTxt}>
                {getMeaning("PP.DTRTNTNDSCPBOLD")}
              </Typography>
              <Typography variant="body1" sx={styles.LabelTxt}>
                {getMeaning("PP.DTRTNTNDSCP")}
              </Typography>
            </Box>

            <>
              <Typography variant="body" gutterBottom sx={styles.SubHeadingTxt}>
                {getMeaning("PP.DTRTNTNLBLTWOB")}
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography ml={0.7} variant="body1" sx={styles.BoldLabelTxt}>
                  {getMeaning("PP.DTRTNTNDSCPBOLDB1")}
                </Typography>
                <Typography variant="body1" sx={styles.LabelTxt}>
                  {getMeaning("PP.DTRTNTNDSCPBOLDV1")}
                </Typography>
              </Box>
              <Box sx={{ display: "flex" }}>
                <Typography ml={0.7} variant="body1" sx={styles.BoldLabelTxt}>
                  {getMeaning("PP.DTRTNTNDSCPBOLDB2")}
                </Typography>
                <Typography variant="body1" sx={styles.LabelTxt}>
                  {getMeaning("PP.DTRTNTNDSCPBOLDV2")}
                </Typography>
              </Box>
              <Box sx={{ display: "flex" }}>
                <Typography ml={0.7} variant="body1" sx={styles.BoldLabelTxt}>
                  {getMeaning("PP.DTRTNTNDSCPBOLDB3")}
                </Typography>
                <Typography variant="body1" sx={styles.LabelTxt}>
                  {getMeaning("PP.DTRTNTNDSCPBOLDV3")}
                </Typography>
              </Box>
            </>

            <>
              <Typography variant="body" gutterBottom sx={styles.SubHeadingTxt}>
                {getMeaning("PP.DTRTNTNLBLTWOC")}
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography ml={0.7} variant="body1" sx={styles.BoldLabelTxt}>
                  {getMeaning("PP.DTRTNTNDSCPBOLDC1")}
                </Typography>
                <Typography variant="body1" sx={styles.LabelTxt}>
                  {getMeaning("PP.DTRTNTNDSCPBOLDCV1")}
                </Typography>
              </Box>
              <Box sx={{ display: "flex" }}>
                <Typography ml={0.7} variant="body1" sx={styles.BoldLabelTxt}>
                  {getMeaning("PP.DTRTNTNDSCPBOLDC2")}
                </Typography>
                <Typography variant="body1" sx={styles.LabelTxt}>
                  {getMeaning("PP.DTRTNTNDSCPBOLDCV2")}
                </Typography>
              </Box>
              <Box sx={{ display: "flex" }}>
                <Typography ml={0.7} variant="body1" sx={styles.BoldLabelTxt}>
                  {getMeaning("PP.DTRTNTNDSCPBOLDC3")}
                </Typography>
                <Typography variant="body1" sx={styles.LabelTxt}>
                  {getMeaning("PP.DTRTNTNDSCPBOLDCV3")}
                </Typography>
              </Box>
              <Box sx={{ display: "flex" }}>
                <Typography ml={0.7} variant="body1" sx={styles.BoldLabelTxt}>
                  {getMeaning("PP.DTRTNTNDSCPBOLDC4")}
                </Typography>
                <Typography variant="body1" sx={styles.LabelTxt}>
                  {getMeaning("PP.DTRTNTNDSCPBOLDCV4")}
                </Typography>
              </Box>
            </>
          </Box>

          {/* 5. How We Use the Information */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom sx={styles.HeadingTxt}>
              {getMeaning("PP.USRRIGHTLBL")}
            </Typography>
            <Typography variant="body1" sx={styles.LabelTxt}>
              {getMeaning("PP.USRRIGHTDSCP")}
            </Typography>

            <Typography variant="body1" sx={styles.BulletDescpTxt}>
              {getMeaning("PP.USRRIGHTPNTONE")}
            </Typography>
            <Typography variant="body1" sx={styles.BulletDescpTxt}>
              {getMeaning("PP.USRRIGHTPNTTWO")}
            </Typography>
            <Typography variant="body1" sx={styles.BulletDescpTxt}>
              {getMeaning("PP.USRRIGHTPNTTHREE")}
            </Typography>
            <Typography variant="body1" sx={styles.BulletDescpTxt}>
              {getMeaning("PP.USRRIGHTPNTFOUR")}
            </Typography>
            <Typography variant="body1" sx={styles.BulletDescpTxt}>
              {getMeaning("PP.USRRIGHTPNTFIVE")}
            </Typography>
          </Box>

          {/* 6. Data Sharing and Security */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom sx={styles.HeadingTxt}>
              {getMeaning("PP.SCUREINFOLBL")}
            </Typography>
            <Typography variant="body1" sx={styles.LabelTxt}>
              {getMeaning("PP.SCUREINFODSCP")}
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography ml={0.7} variant="body1" sx={styles.BoldLabelTxt}>
                {getMeaning("PP.SCUREINFOLBLB1")}
              </Typography>
              <Typography variant="body1" sx={styles.LabelTxt}>
                {getMeaning("PP.SCUREINFOLBLBV1")}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography ml={0.7} variant="body1" sx={styles.BoldLabelTxt}>
                {getMeaning("PP.SCUREINFOLBLB2")}
              </Typography>
              <Typography variant="body1" sx={styles.LabelTxt}>
                {getMeaning("PP.SCUREINFOLBLBV2")}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography ml={0.7} variant="body1" sx={styles.BoldLabelTxt}>
                {getMeaning("PP.SCUREINFOLBLB3")}
              </Typography>
              <Typography variant="body1" sx={styles.LabelTxt}>
                {getMeaning("PP.SCUREINFOLBLBV3")}
              </Typography>
            </Box>
          </Box>

          {/* 7. Data Storage and Retention */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom sx={styles.HeadingTxt}>
              {getMeaning("PP.CHLDRNPRVCYLBL")}
            </Typography>

            <Typography variant="body1" sx={styles.LabelTxt}>
              {getMeaning("PP.CHLDRNPRVCYDSCP1")}
            </Typography>

            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography variant="body1" sx={styles.LabelTxt}>
                {getMeaning("PP.CHLDRNPRVCYDSCP2")}
              </Typography>
              <Typography variant="body1" sx={styles.BoldLabelTxt}>
                {getMeaning("PP.CHLDRNPRVCYDSCPB2")}
              </Typography>
            </Box>
            <Typography variant="body1" sx={styles.LabelTxt}>
              {getMeaning("PP.CHLDRNPRVCYDSCP3")}
            </Typography>
          </Box>

          {/* 8. Children’s Privacy */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom sx={styles.HeadingTxt}>
              {getMeaning("PP.COKSTRCKTECHLBL")}
            </Typography>
            <Typography variant="body1" sx={styles.LabelTxt}>
              {getMeaning("PP.COKSTRCKTECHDSCP")}
            </Typography>
          </Box>

          {/* 9. User Rights */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom sx={styles.HeadingTxt}>
              {getMeaning("PP.INTRNTNLDATATRNSFRLBL")}
            </Typography>
            <Typography variant="body1" sx={styles.LabelTxt}>
              {getMeaning("PP.INTRNTNLDATATRNSFRDSCP")}
            </Typography>
            <Typography variant="body1" sx={styles.LabelTxt}>
              {getMeaning("PP.INTRNTNLDATATRNSFRDSCP1")}
            </Typography>
            <Typography variant="body1" sx={styles.LabelTxt}>
              {getMeaning("PP.INTRNTNLDATATRNSFRDSCP2")}
            </Typography>
            <Typography variant="body1" sx={styles.LabelTxt}>
              {getMeaning("PP.INTRNTNLDATATRNSFRDSCP3")}
            </Typography>
            <Typography variant="body1" sx={styles.LabelTxt}>
              <strong>{getMeaning("PP.CNTCTEMLLBL")}</strong>{" "}
              <Link href="mailto:contact@acrossassist.com" underline="hover">
                {getMeaning("PP.CNTCTEML")}
              </Link>
              <br />
            </Typography>
          </Box>

          {/* 10. Policy Updates */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom sx={styles.HeadingTxt}>
              {getMeaning("PP.CHNGSTOPLCYLBL")}
            </Typography>
            <Typography variant="body1" sx={styles.LabelTxt}>
              {getMeaning("PP.CHNGSTOPLCYDSCP")}
            </Typography>
          </Box>

          {/* 11. Contact Us */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" gutterBottom sx={styles.HeadingTxt}>
              {getMeaning("PP.CNTCTUSLBL")}
            </Typography>
            <Typography variant="body1" sx={styles.LabelTxt}>
              {getMeaning("PP.CNTCTUSDSCP")}
            </Typography>

            <Box sx={{ mt: 0 }}>
              <Typography variant="body1" sx={styles.LabelTxt}>
                <strong>{getMeaning("PP.CNTCTEMLLBL")}</strong>{" "}
                <Link href="mailto:contact@acrossassist.com" underline="hover">
                  {getMeaning("PP.CNTCTEML")}
                </Link>
                <br />
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Box>
    </div>
  );
};

export default RetailerAppPolicy;

const styles = {
  PPHeadingTxt: {
    color: "black",
    fontWeight: "600",
    fontSize: "1.2rem",
    fontFamily: '"Poppins", serif',
  },
  HeadingTxt: {
    color: "black",
    fontSize: "1.2rem",
    fontFamily: '"Poppins", serif',
  },
  SubHeadingTxt: {
    color: "black",
    fontSize: "1.05rem",
    fontFamily: '"Poppins", serif',
    fontWeight: "500",
  },
  BoldLabelTxt: {
    color: "black",
    fontSize: "0.9rem",
    fontFamily: '"Poppins", serif',
    fontWeight: "500",
  },
  LabelTxt: {
    color: "black",
    fontSize: "0.9rem",
    fontFamily: '"Poppins", serif',
  },
  BulletDescpTxt: {
    ml: 2,
    color: "black",
    fontSize: "0.91rem",
    fontFamily: '"Poppins", serif',
  },
};
